import { BridgewayGlyph } from '../BridgewayGlyph';

export const ImageEditingOverlay = () => (
	<div
		className="absolute inset-0 flex items-center justify-center bg-black/45
			backdrop-blur-[2px]"
		role="status"
		aria-label="Regenerating image"
	>
		<div className="flex flex-col items-center gap-2 text-white">
			<BridgewayGlyph size={48} />
			<p className="font-adobe-clean-display text-[14px] font-bold">
				Regenerating…
			</p>
		</div>
	</div>
);
